module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments-50.b23ad9e8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments-50.png
// module id = 3705
// module chunks = 11